<template>
    <div class="content with-pagination">
        <router-view @refresh="refresh()"></router-view>
        <header class="content-header">
            <div class="wrapper">

                <div>
                    <h1>Taxes</h1>
                    <p>Gestion des taxes</p>

                    <div class="datagrid-results"><strong>{{paginator.total}}</strong> Résultats trouvés</div>
                </div>

              <actions-dropdown>
                <li v-if="$aclInterfaceValidator('weeboxcore.tax.create')" class="main" @click="create()">
                  <icon name="file-plus-02"/>
                  <span>Créer une taxe</span>
                </li>
              </actions-dropdown>


            </div>
        </header>

        <filters v-model="filters" :paginator="paginator" :menus="menus" active-nav="true" active-tabs="true" @refresh="refresh()" @setFilter="setFilter"></filters>

        <div class="content-body">

            <section>

                <no-results v-model="resources" :clear="resetFilter"></no-results>

                <div v-if="resources && resources.length" class="datagrid" :class="paginator.listing">
                    <div class="datagrid-header">
                        <div>
                            <div></div>
                            <div class="picture"></div>
                            <div class="center">
                              <datagrid-sort :data="[{name:'ID', value:'id'}]" v-model="paginator"></datagrid-sort>
                            </div>
                            <div>
                              <datagrid-sort :data="[{name:'Pays', value:'country_id'}]" v-model="paginator"></datagrid-sort>
                            </div>
                            <div>
                              <datagrid-sort :data="[{name:'Type de taxe', value:'type_id'}]" v-model="paginator"></datagrid-sort>
                            </div>
                            <div>
                              <datagrid-sort :data="[{name:'Pourcentage', value:'percentage'}]" v-model="paginator"></datagrid-sort>
                            </div>
                            <div class="actions"></div>
                            <div></div>
                        </div>
                    </div>
                    <div class="datagrid-body">
                        <div v-for="item in resources" @dblclick="edit(item.id)" v-bind:class="setClassDataRaw( 'weeboxcore.tax.view', item.id )">
                            <div></div>
                            <div class="picture no-radius">
                                <figure>
                                    <img v-bind:style="{background: 'no-repeat center', backgroundImage: 'url('+'/src/assets/flags/'+item.country_id+'.svg'+')', backgroundSize: '50% auto'}"
                                         src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=">
                                </figure>
                            </div>
                            <div data-field="id" class="center"><span class="id">{{ item.id }}</span></div>
                            <div data-field="country_id">{{ item.country ? item.country.name : '-' }}</div>
                            <div data-field="type_id">{{ item.type ? item.type.name : '-' }}</div>
                            <div data-field="percentage">{{ item.percentage }} %</div>
                            <div class="actions">
                                <ul>
                                    <li v-if="$aclInterfaceValidator('weeboxcore.tax.delete', item.id)"><button @click="remove(item.id)"><icon name="trash-01"/></button></li>
                                    <li v-if="$aclInterfaceValidator('weeboxcore.tax.update', item.id)"><button @click="edit(item.id)"><icon name="pencil-02"/></button></li>
                                </ul>
                            </div>
                            <div></div>
                        </div>
                    </div>
                </div>
            </section>

            <component-paginator v-model="paginator" v-on:refresh="refresh"></component-paginator>

        </div>
    </div>
</template>
<script>
    import TaxService from './TaxService.js';
    import Index from '../../../layouts/Index.vue';

    export default {
        extends: Index,
        data () {
            return {
                menus: [
                    {
                        slug: 'tax',
                        name: 'Pays'
                    },
                    {
                        slug: 'taxtype',
                        name: 'Type'
                    }
                ]
            }
        },
        mounted: function(){
            this.refresh()
        },
        methods: {
            getResource: function(){
                return TaxService;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/config/tax/Index.vue